export default "__VITE_ASSET__pI51WHas__"